// ============================================================
// 盘面元素释义数据 —— 供宫位详情弹窗展示「意思与意象」
// 文字取传统奇门通用象义，简明化整理，仅供研究参考。
// ============================================================

// 十干意象（含奇仪专名）
export const GAN_MEANINGS = {
  戊: { tag: '天门 · 资本', text: '钱财、房产、土地、工程、资本；厚重稳健，主积蓄与根基。' },
  己: { tag: '地户 · 私欲', text: '想法谋划、私欲暗昧、田园坟地；主曲折婉转、心思细腻。' },
  庚: { tag: '天狱 · 阻隔', text: '阻碍、仇人、道路阻隔、兵器机械；刚硬肃杀，也为丈夫、对手之象。' },
  辛: { tag: '天庭 · 罪错', text: '错误、变革革新、金银细软、精密之物；也为妾从、批评之象。' },
  壬: { tag: '天牢 · 流动', text: '江河车船、贸易运输、流动不居；也主困境羁绊，智慧而多变。' },
  癸: { tag: '天网 · 暗昧', text: '雨露地下水、阴谋纠缠、网罗陷阱；主暧昧不明、暗中牵扯。' },
  丁: { tag: '星奇 · 玉女', text: '灯火文书、信息灵感、机要秘密；玉女柔情，主心灵手巧。' },
  丙: { tag: '月奇 · 天威', text: '太阳权威、光明热烈、明礼昭示；性急如火，主声名势力。' },
  乙: { tag: '日奇 · 仁德', text: '花草中医、柔顺委婉、艺文生机；妻子之象，主希望与转机。' },
  甲: { tag: '青龙 · 首领', text: '甲为旬首遁于六仪之下，不单现于盘面；主统领、开端、栋梁。' },
};

// 八神（含九神盘的太常）
export const SHEN_MEANINGS = {
  值符: { luck: '吉', text: '八神之首，贵神所至百恶消散；主贵人、领导、权威、正统。' },
  直符: { luck: '吉', text: '八神之首，贵神所至百恶消散；主贵人、领导、权威、正统。' },
  螣蛇: { luck: '凶', text: '主虚惊怪异、缠绕变诈、惊恐不安；也主宗教玄学、梦境之缘。' },
  太阴: { luck: '吉', text: '主隐蔽暗助、女人阴私、筹划密谋；得之有人暗中庇护。' },
  六合: { luck: '吉', text: '主婚姻合作、交易中介、人缘和合；多主成群结伴之事。' },
  白虎: { luck: '凶', text: '主凶伤斗打、疾病丧事、道路阻隔；亦主军警威权、肃杀之力。' },
  玄武: { luck: '凶', text: '主盗贼欺骗、暧昧不明、丢失暗失；亦主聪慧机巧、暗中行事。' },
  九地: { luck: '吉', text: '主安静稳固、藏匿固守、低伏潜藏；利久远屯守之事。' },
  九天: { luck: '吉', text: '志高气昂、飞腾上升；主远行动武、扩张张扬，好动之象。' },
  太常: { luck: '吉', text: '主衣冠礼乐、酒食宴饮、文章印信；九神盘所独有，居中五之位。' },
};

// 九星
export const STAR_MEANINGS = {
  天蓬: { text: '水贼之星，胆大妄为；主风险争夺，宜守不宜攻，忌行险侥幸。' },
  天芮: { text: '病星师道，主疾病、朋友、授业求学；得奇门吉格可化凶为吉。' },
  天冲: { text: '慈心造化，机敏果断；主行动冲击、征伐出击，利速战速决。' },
  天辅: { text: '文曲文昌，主文化教育、考试功名；四吉星之一，大吉大利。' },
  天禽: { text: '土星居中五，寄坤二随天芮同行；主忠厚守信、中正平和。' },
  天心: { text: '天医之星，主医药健康、领导才能、深谋远虑；利求医谋事。' },
  天柱: { text: '破坏之星，主口舌词讼、毁折破损；亦利坚守门户、据理力争。' },
  天任: { text: '富室之星，主田土房产、负重致远；吉庆安稳，利置业谋产。' },
  天英: { text: '烈火文明，主礼仪才华、血光急躁；利文化文艺，防过旺生非。' },
};

// 八门
export const MEN_MEANINGS = {
  休门: { text: '吉门（水）。主休养生息、贵人扶持；利谒见求贵、婚姻修造。' },
  生门: { text: '吉门（土）。主生意生长、财富源源；最利求财、造葬、置业。' },
  伤门: { text: '凶门（木）。主伤害争斗、捕猎讨债；宜收敛不宜妄动。' },
  杜门: { text: '平门（木）。主闭塞隐藏、防守保密；利避难藏身、技术钻研。' },
  景门: { text: '平门（火）。主文书消息、血光虚华；利考试献策、通信广告。' },
  死门: { text: '凶门（土）。主死亡丧葬、刑狱困滞；唯利吊丧、捕猎、了断。' },
  惊门: { text: '凶门（金）。主惊恐官司、口舌诉讼；利擒盗诉讼、以言制胜。' },
  开门: { text: '吉门（金）。主开创启动、上任远行；利开业求名、事业起步。' },
};

// 空亡总义
export const KONG_MEANING = '空亡＝旬空之地支落临此宫，主落空、不实、事体难成或有名无实；日空应自身与当下，时空应此事之时机。古诀云「逢冲则实，逢合则绊」，待值冲填实之期方见分晓。';

// 门迫 / 击刑 / 入墓 总义
export const HARM_MEANING = {
  门迫: '门克其宫谓之迫，吉门被迫则吉减半，凶门被迫则凶更甚；主事多阻力、强扭难成。',
  击刑: '六仪落刑宫谓之击刑，主自相矛盾、刑伤波折、事涉官非；谋事宜避。',
  入墓: '干／门／星落五行墓库谓之入墓，主能力被埋没、事情受困捂；待冲开墓库方有转机。',
};
